import i18n from '@/utils/i18n';
import React from 'react';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

const RETRY_BUTTON_WIDTH = 120;

interface AccountListFetchMoreErrorProps {
  onRetry: () => void;
}

export const AccountListFetchMoreError: React.FC<
  AccountListFetchMoreErrorProps
> = ({ onRetry }) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <Typography color={theme.sk.color.text.secondary} variant="paragraph-md">
        {i18n.t('sales_portal.account_list.error')}
      </Typography>
      <Button
        accessibilityLabel={i18n.t('sales_portal.error.retry')}
        onPress={onRetry}
        size={ButtonSize.Medium}
        variant={ButtonVariant.Secondary}
        width={RETRY_BUTTON_WIDTH}
      >
        {i18n.t('sales_portal.error.retry')}
      </Button>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    gap: theme.sk.spacing.spaceSMedium,
    paddingVertical: theme.sk.spacing.spaceMedium,
  },
}));
